import React from "react";
import PropTypes from "prop-types";

function Points(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props?.size || "39"}
      height={props?.size - 11 || "28"}
      viewBox="0 0 39 28"
      style={{ height: "auto" }}
      {...props}
    >
      <defs>
        <linearGradient id="mas4tkntnb" x1="50%" x2="50%" y1="0%" y2="100%">
          <stop offset="0%" stopColor="#FDA700" />
          <stop offset="100%" stopColor="#FB6E00" />
        </linearGradient>
        <filter id="gai3mqrnra">
          <feColorMatrix
            in="SourceGraphic"
            values="0 0 0 0 0.847000 0 0 0 0 0.847000 0 0 0 0 0.847000 0 0 0 1.000000 0"
          />
        </filter>
      </defs>
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <g
                filter="url(#gai3mqrnra)"
                transform="translate(-1110 -532) translate(0 515) translate(896) translate(214.5 12)"
              >
                <g
                  fill="url(#mas4tkntnb)"
                  fillRule="nonzero"
                  transform="translate(0 5)"
                >
                  <path
                    fill-opacity=".2"
                    d="M37.222 15.32c-.134-1.034-1.128-1.86-2.991-2.465-1.507-.486-3.414-.78-5.492-.828V3.54c0-.175-.052-.342-.156-.478-.245-.922-1.24-1.67-2.962-2.227C23.951.295 21.77 0 19.476 0c-2.286 0-4.446.294-6.079.835-1.343.446-2.954 1.273-2.954 2.697 0 .087.007.175.022.262l.082 3.628C5.73 6.427 1.077 9.824.156 14.994.052 15.575 0 16.172 0 16.768c0 5.25 3.986 9.522 8.884 9.522 2.041 0 4.016-.756 5.604-2.132 1.395.35 3.028.54 4.758.557.378 2.203 4.831 3.213 8.988 3.213 2.286 0 4.438-.302 6.086-.85 1.35-.446 2.954-1.281 2.954-2.705V15.63c0-.104-.015-.215-.052-.31z"
                  />
                  <path d="M37.222 15.364c-.134-1.034-1.128-1.861-2.991-2.466-1.507-.485-3.414-.78-5.492-.827V3.584c0-.175-.052-.343-.156-.478-.245-.922-1.24-1.67-2.962-2.227-1.67-.54-3.852-.835-6.145-.835-2.286 0-4.446.294-6.079.835-1.343.445-2.954 1.273-2.954 2.697 0 .087.007.175.022.262l.082 3.627C5.73 6.471 1.077 9.868.156 15.038.052 15.618 0 16.215 0 16.812c0 5.25 3.986 9.522 8.884 9.522 2.041 0 4.016-.756 5.604-2.132 1.395.35 3.028.54 4.758.557.378 2.203 4.831 3.213 8.988 3.213 2.286 0 4.438-.302 6.086-.851 1.35-.445 2.954-1.28 2.954-2.705v-8.742c0-.103-.015-.214-.052-.31zM13.842 2.398c1.5-.493 3.504-.771 5.641-.771 2.123 0 4.201.278 5.715.771 1.61.525 1.96 1.066 1.96 1.178 0 .11-.35.66-1.967 1.177-1.507.485-3.585.771-5.708.771-2.048 0-3.993-.254-5.47-.715-1.596-.494-2.041-1.043-2.078-1.218 0-.015 0-.023-.008-.023.008-.112.35-.653 1.915-1.17zm13.412 3.166v2.037c-.067.11-.104.246-.096.381 0 .104-.35.653-1.967 1.178-1.507.485-3.593.771-5.715.771-1.834 0-3.63-.207-5.055-.596-.022-.008-.037-.008-.06-.016-.704-.597-1.484-1.066-2.322-1.408l-.052-2.243c.512.278 1.046.5 1.603.66 1.61.501 3.696.771 5.886.771 2.293 0 4.475-.294 6.138-.835.571-.167 1.12-.405 1.64-.7zm-13.39 17.11c-3.02 2.952-7.704 2.713-10.45-.525-2.746-3.237-2.53-8.256.49-11.2 1.366-1.328 3.14-2.068 4.98-2.068.743 0 1.485.12 2.197.35 2.568.867 4.505 3.15 5.062 5.974.097.525.149 1.066.149 1.599 0 2.243-.884 4.375-2.427 5.87zm1.886.175c.601-.787 1.083-1.67 1.425-2.617.63.056 1.299.096 1.982.104v.143l.037 2.697c-1.15-.016-2.301-.128-3.444-.327zm1.974-6.984c.438.032.89.048 1.35.056 0 .016.008.04.008.056l.045 2.76c-.527-.008-1.04-.032-1.537-.072.112-.612.171-1.24.171-1.861.008-.31-.007-.62-.037-.939zm1.826-1.527h-.067c-.712 0-1.403-.032-2.041-.08-.282-1.065-.727-2.068-1.329-2.959 1.114.152 2.235.231 3.363.231 2.293 0 4.475-.294 6.145-.835.572-.191 1.114-.422 1.633-.716v2.108c-3.191.095-6.487.811-7.704 2.251zm.994 1.225c.075-.223.617-.74 2.138-1.201 1.447-.438 3.333-.676 5.314-.676h.097c2.123 0 4.2.262 5.715.755 1.566.51 1.937 1.019 1.96 1.154v.008c-.008.12-.38.668-2.027 1.193-1.522.485-3.525.748-5.648.748-2.004 0-3.92-.247-5.389-.684-1.417-.43-1.989-.915-2.13-1.162-.007-.047-.015-.095-.03-.135zm15.246 8.853c0 .112-.334.66-1.908 1.186-1.507.5-3.51.78-5.648.78-2.145 0-4.15-.271-5.634-.756-1.573-.517-1.892-1.05-1.892-1.17v-.016l-.037-2.299c1.766.963 4.713 1.4 7.414 1.4 2.294 0 4.461-.294 6.124-.835.549-.175 1.076-.413 1.58-.7v2.41zm-.067-4.406c0 .111-.342.652-1.945 1.177-1.521.493-3.54.764-5.693.764-4.074 0-6.835-.979-7.444-1.75l-.015-.685-.03-1.821c.542.294 1.106.525 1.693.692 1.595.477 3.651.748 5.789.748 2.256 0 4.409-.287 6.064-.812.571-.175 1.12-.405 1.64-.7v2.045h.008c0 .103-.067.222-.067.342z" />
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

Points.propTypes = {
  size: PropTypes.number,
};

export default Points;
